import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { Button } from 'react-bootstrap';
import styles from '../styles/about/CookieConsent.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { setCookie } from './cookieTools';

var PersonalCookieNotice = function PersonalCookieNotice(props) {
  var cookies = props.cookies,
      close = props.close;
  var router = useRouter();

  var saveCookies = function saveCookies() {
    var opt = _objectSpread(_objectSpread({}, cookies), {}, {
      categories: _objectSpread(_objectSpread({}, cookies.categories), {}, {
        personal: 1
      }),
      consentDate: new Date()
    });

    setCookie('ckconso', JSON.stringify(opt), 90);
    close();
    router.reload(window.location.pathname);
  };

  return __jsx("dialog", {
    className: styles.root
  }, __jsx("div", {
    className: styles.dialogOverlay
  }), __jsx("div", {
    className: styles.container
  }, __jsx("div", {
    className: styles.consentRoot
  }, __jsx("p", {
    className: "heading3 text-center font-weight-bold"
  }, "Set\u0103rile de personalizare sunt inactive"), __jsx("p", {
    className: styles.infoText
  }, "F\u0103r\u0103 aceste cookies, ", __jsx("strong", null, "datele completate \xEEn formularul de compara\u021Bii RCA pot fi pierdute"), ", pe parcursul navigarii \xEEn site. Activeaz\u0103 aceste cookies pentru o experien\u021B\u0103 mai bun\u0103 de utilizare a portalului."), __jsx("p", {
    className: styles.infoText
  }, "Afl\u0103 mai multe \xEEn ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/cookies")
  }, __jsx("a", {
    title: "Politica Cookies",
    target: "_blank"
  }, "Politica privind cookies")), "."), __jsx("div", {
    className: "d-flex justify-content-around"
  }, __jsx(Button, {
    variant: "secondary",
    onClick: saveCookies
  }, "Activeaz\u0103"), __jsx(Button, {
    variant: "link",
    onClick: close
  }, __jsx(FontAwesomeIcon, {
    icon: faTimes,
    height: "16",
    width: "16",
    className: "mr-2"
  }), "\xCEnchide")))));
};

export default PersonalCookieNotice;